export const DefaultNativeTokenContractAddress = "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee";

export const TON_BRIDGE_API = "https://bridge.tonapi.io/bridge";

export const TON_BRIDGE_STORE_KEY = "ton-connect-http-bridge-lastEventId";

export const TON_DEFAULT_TTL = 300;
